import React from "react";
import { useState, useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { connect, useSelector } from "react-redux";
import { ApplicationState } from "../store";
import * as APIStore from "../store/APIStore";
import MUIDataTable from "mui-datatables";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { TableFooter, TableCell, TableRow, Paper, Slide } from "@material-ui/core";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import RequestAccessToken from "../util/authService";
import DoneAllIcon from '@material-ui/icons/DoneAll';
import { red } from '@material-ui/core/colors';
import { shouldTryRefMDProfile } from "./common/ProfileHelper";
const SPACED_DATE_FORMAT = "MM-DD-YYYY";
import Hidden from '@material-ui/core/Hidden';
import { Grid } from '@material-ui/core';
import { Typography } from "@material-ui/core";
import './style.css';
import './PatientsTable.css';

type PatientsByRefMDProps = {
    Patients : APIStore.PatientState,
    userRefMdProfile : APIStore.RefMDProfileState
} &
    typeof APIStore.actionCreators &
    RouteComponentProps<{ RefMdId: string }>;

const fetchPatientsForRefMD = (
    accessToken: string,
    refMDIdStr: string,
    actionMethod: Function
) => {
    const refMDIdArg = parseInt(refMDIdStr) || 0;
    actionMethod(refMDIdArg, -6, true, accessToken);
};

const formatDate = (date: string | undefined, dateOnly: any) => {
    if (!date) {
        return 'N/A';
    }
    if (dateOnly) {
        return moment(date).format("MM-DD-YYYY");
    }
    return moment(date).format("hh:mm:ss A MM-DD-YYYY");
};

const getMuiTheme = () =>
    createTheme({

    });

const PatientsTable = (props: PatientsByRefMDProps) => {
    let [patientsState, setPatientState] = useState<APIStore.ListPatient | {}>({});
    let [tokenState, setTokenState] = useState<APIStore.TokenType>();

    let { requestPatientsByRefMDIdWithDays, Patients, requestConsolidatedPatientById, requestVitalsMdProfile, requestMessageContactsUser } = props;

    let userRefMdProfile: APIStore.RefMDProfileState = props.userRefMdProfile;

    let { patientsByRefMDId, isLoading, isLoaded, isError, errorMessage, fullPatients } = Patients;

    const tableColumns = [
        {
            name: "Readmit",
            options: {
                display: true,
                setCellProps: () => ({ style: { minWidth: "50px", maxWidth: "50px" } }),
                filter: false
            },
        },
        {
            name: "id",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "Facility",
            options: {
                filterType: 'checkbox'
            }
        },
        {
            name: "First Name",
            options: {
                filter: false
            }
        },
        {
            name: "Last Name",
            options: {
                filter: false
            }
        },
        {
            name: "AdmitDate",
            label: "Admit Date",
            options: {
                sort: true,
                customBodyRender: value => {
                    let dt = moment(new Date(value));


                    if (dt.isValid()) {
                        return dt.format(SPACED_DATE_FORMAT);;
                    } else {
                        return 'N/A'
                    }
                },
                filter: false
            }
        },
        {
            name: "DischargeDate",
            label: "Days to Discharge",
            options: {
                filter: false
            }
        },
        {
            name: "Policy No",
            options: {
                filter: false
            }
        }
    ];

    let tokenStatePr = RequestAccessToken().then((token) => {
        if (token && !tokenState) {
            setTokenState(token);
        }
    });

    useEffect(() => {
        if ((shouldTryRefMDProfile(userRefMdProfile)) && tokenState?.accessToken) {
            requestVitalsMdProfile(tokenState.accessToken);
        }
    }, [tokenState]);

    useEffect(() => {
        if (tokenState?.accessToken && userRefMdProfile.isLoaded) {
            requestMessageContactsUser(tokenState.accessToken)
            fetchPatientsForRefMD(
                tokenState.accessToken,
                props.match.params.RefMdId,
                requestPatientsByRefMDIdWithDays
            );
        }
    }, [tokenState, userRefMdProfile]);

    const options = {
        onRowClick: (
            rowData: string[],
            rowMeta: { dataIndex: number; rowIndex: number }
        ) => patientRowClick(rowData, rowMeta),
        elevation: 0,
        filter: true,
        viewColumns: false,
        selectableRows: false,
        print: true,
        delete: false,
        download: true,
        searchAlwaysOpen: false,
        responsive: 'vertical',
        customRowRender: (data, dataIndex, rowIndex) => {
            if (data[0] > 0) {
                return (
                    <TableRow onClick={() => patientRowClick(data)} >
                        <Hidden mdUp>
                            <TableCell size='small'><DoneAllIcon fontSize="small" style={{ color: red[500], padding: '0px' }} /></TableCell>
                            <TableCell>
                                <Grid container direction="row" className="notificationsgrid">
                                    <Grid item xs={12}>
                                        <Typography variant="overline" component="div">
                                            {
                                                data[2]
                                            }
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body1" component="div" gutterBottom>
                                            {
                                                data[3]
                                            }&nbsp;
                                            {
                                                data[4]
                                            }
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="body2" component="div" gutterBottom>
                                            <strong>Admitted: </strong>{
                                                data[5]
                                            }
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" component="div" gutterBottom>
                                            <strong>Days to Discharge: </strong>{
                                                data[6]
                                            }
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" component="div" gutterBottom>
                                            <strong>Policy No: </strong>{
                                                data[7]
                                            }
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </TableCell>
                        </Hidden>
                        <Hidden smDown>
                            <TableCell size='small'><DoneAllIcon fontSize="small" style={{ color: red[500], padding: '0px' }} /></TableCell>
                            <TableCell colSpan={1}>
                                {
                                    data[2]
                                }
                            </TableCell>
                            <TableCell colSpan={1}>
                                {
                                    data[3]
                                }
                            </TableCell>
                            <TableCell colSpan={1}>
                                {
                                    data[4]
                                }
                            </TableCell>
                            <TableCell colSpan={1}>
                                {
                                    data[5]
                                }
                            </TableCell>
                            <TableCell colSpan={1}>
                                {
                                    data[6]
                                }
                            </TableCell>
                            <TableCell colSpan={1}>
                                {
                                    data[7]
                                }
                            </TableCell>
                        </Hidden>
                    </TableRow>
                )
            }
            return (
                <TableRow onClick={() => patientRowClick(data)} >




                    <Hidden mdUp>
                        <TableCell size='small'>&#8239;</TableCell>
                        <TableCell>
                            <Grid container direction="row" className="notificationsgrid">
                                <Grid item xs={12}>
                                    <Typography variant="overline" component="div">
                                        {
                                            data[2]
                                        }
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body1" component="div" gutterBottom>
                                        {
                                            data[3]
                                        }&nbsp;
                                        {
                                            data[4]
                                        }
                                    </Typography>
                                </Grid>

                                <Grid item xs={6}>
                                    <Typography variant="body2" component="div" gutterBottom>
                                        <strong>Admitted: </strong>{
                                            data[5]
                                        }
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2" component="div" gutterBottom>
                                        <strong>Days to Discharge: </strong>{
                                            data[6]
                                        }
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2" component="div" gutterBottom>
                                        <strong>Policy No: </strong>{
                                            data[7]
                                        }
                                    </Typography>
                                </Grid>

                            </Grid>
                        </TableCell>
                    </Hidden>




                    <Hidden smDown>
                        <TableCell size='small'>&#8239;</TableCell>
                        <TableCell colSpan={1}>
                            {
                                data[2]
                            }
                        </TableCell>
                        <TableCell colSpan={1}>
                            {
                                data[3]
                            }
                        </TableCell>
                        <TableCell colSpan={1}>
                            {
                                data[4]
                            }
                        </TableCell>
                        <TableCell colSpan={1}>
                            {
                                data[5]
                            }
                        </TableCell>
                        <TableCell colSpan={1}>
                            {
                                data[6]
                            }
                        </TableCell>
                        <TableCell colSpan={1}>
                            {
                                data[7]
                            }
                        </TableCell>
                    </Hidden>
                </TableRow>);

        }
    };

    const loadingOptions = {
        filter: false,
        viewColumns: false,
        print: false,
        elevation: 0,
        sort: false,
        download: false,
        customRowRender: (data, dataIndex, rowIndex) => {
            if (dataIndex === 0) {
                return (

                    <TableRow className="animate-flicker">
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                    </TableRow>
                );
            }

            return (
                <TableRow className="animate-flicker">
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>

                </TableRow>
            );
        },

        customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
            const startIndex = page * rowsPerPage;
            const endIndex = (page + 1) * rowsPerPage;
            return (
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={1}>Loading</TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                    </TableRow>
                </TableFooter>
            );
        },
        searchAlwaysOpen: true,
        textLabels: {
            body: {
                noMatch: "Loading",
            },
        },
    };


    const errorOptions = {
        filter: false,
        viewColumns: false,
        print: false,
        elevation: 0,
        sort: false,
        download: false,

        customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
            const startIndex = page * rowsPerPage;
            const endIndex = (page + 1) * rowsPerPage;
            return (
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={1}>{`Error: ${errorMessage}`}</TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                    </TableRow>
                </TableFooter>
            );
        },
        searchAlwaysOpen: false,
        textLabels: {
            body: {
                noMatch: "Error",
            },
        },
    };

    const history = useHistory();


    const patientRowClick = (
        rowData: string[]
    ) => {
        let ptId = rowData[1];
        history.push(`/Patient/${ptId}`);
    };

    if (isLoading || !isLoaded) {
        return (
            <Slide in timeout={1000} direction="left">
                <div className="maincontent">
                    <Paper elevation={1} style={{ padding: 50 }}>
                        <div className="mui-datatable" >
                            <MUIDataTable
                                key={'maintableloading'}
                                title={"Patients"}
                                data={[
                                    ["col1", "col2", "col3", "col4", "col5", "col6"],
                                    ["col1", "col2", "col3", "col4", "col5", "col6"],
                                ]}
                                columns={tableColumns}
                                options={loadingOptions}

                            />
                        </div>
                    </Paper>
                </div>
            </Slide>
        );
    }

    if (isError) {
        return (
            <div>
                <div className="mui-datatable">
                    <MUIDataTable
                        title={"Patients"}
                        data={[
                            ["col1", "col2", "col3", "col4", "col5", "col6"],
                            ["col1", "col2", "col3", "col4", "col5", "col6"],
                        ]}
                        columns={tableColumns}
                        options={errorOptions}

                    />
                </div>
            </div>
        );
    }

    return (
        <Slide in timeout={500} direction="left">
            <div className="maincontent">
                <div className="mui-datatable">
                    <MUIDataTable theme={getMuiTheme()}

                        data={patientsByRefMDId.map((item: APIStore.ListPatient) => {

                            return [
                                item.recentAdmits,
                                item.ptId,
                                item.facilityName,
                                item.firstName,
                                item.lastName,
                                formatDate(item.admitDate, true),
                                item.daysToDischarge,
                                item.mbi
                            ];
                        })}
                        columns={tableColumns}
                        options={options}
                    />
                </div>
            </div>
        </Slide>
    );
};

export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(PatientsTable as any);
